import { CardTypes } from "@fresh8/types/src";
import {
  BetDataContext,
  injectBetData
} from "@fresh8/ad-data-composition/src/betData";
import { computed, ComputedRef, inject, InjectionKey, provide } from "vue";

import { Option } from "@fresh8/types/src/betData";

function usePromoOption(cardType: CardTypes, optionIds: string[] | null) {
  const betData = injectBetData() || ({} as BetDataContext);
  const betOptions = computed(() => betData.options.value!);
  const option = computed(() => betOptions.value[optionIds?.[0]!]);

  return computed(() => {
    if (cardType === "promo") {
      return option.value;
    }

    return {} as Option;
  });
}

const MultiPromoSymbol: InjectionKey<ComputedRef<Option>> = Symbol(
  "multi-promo"
);
export function injectPromoOption() {
  return inject(
    MultiPromoSymbol,
    computed(() => ({} as Option))
  );
}
export function providePromoOption(
  cardType: CardTypes,
  optionIds: string[] | null
) {
  provide(MultiPromoSymbol, usePromoOption(cardType, optionIds));
}
